module.exports = __webpack_public_path__ + "static/logo-cube-shadow-b1f1072227dec170e7c20efec8b4bc87.svg";